import React from 'react';
import { CorporateContactEditTemplate } from 'themes/application/corporate/components';
import { observer } from 'mobx-react';
import { CorporateContactEditViewStore } from 'application/corporate/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new CorporateContactEditViewStore(rootStore, componentProps), 'corporateContactEditView')
@observer
class CorporateContactEdit extends React.Component {
    
    render() {
        return <CorporateContactEditTemplate {...this.props} />
    }
}

export default CorporateContactEdit;